export const isServer = (): boolean => typeof window === 'undefined';

export const isClient = (): boolean => !isServer();

export const getIsomorphicFile = (): any => (isServer() ? Object : window.File);
